import { render, staticRenderFns } from "./BookingSystem.vue?vue&type=template&id=15be47b9&"
import script from "./BookingSystem.vue?vue&type=script&lang=js&"
export * from "./BookingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15be47b9')) {
      api.createRecord('15be47b9', component.options)
    } else {
      api.reload('15be47b9', component.options)
    }
    module.hot.accept("./BookingSystem.vue?vue&type=template&id=15be47b9&", function () {
      api.rerender('15be47b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/BookingSystem.vue"
export default component.exports